// extracted by mini-css-extract-plugin
export default {"ClientDetail":"StaffDetail_ClientDetail__btulm","tableResponsive":"StaffDetail_tableResponsive__8eo-W"};